/** @deprecated Use icons from icons-v2-generated instead. */
export function TableViewIcon({
  className = 'w-5 h-5',
  size = 22,
  color = 'white',
}: {
  className?: string;
  size?: number;
  color?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 22"
      fill={color}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.625 20V15.125H1.75C1.12868 15.125 0.625 14.6213 0.625 14C0.625 13.3787 1.12868 12.875 1.75 12.875H9.625V9.125H1.75C1.12868 9.125 0.625 8.62132 0.625 8C0.625 7.37868 1.12868 6.875 1.75 6.875H9.625V2C9.625 1.37868 10.1287 0.875 10.75 0.875C11.3713 0.875 11.875 1.37868 11.875 2V6.875H19.75C20.3713 6.875 20.875 7.37868 20.875 8C20.875 8.62132 20.3713 9.125 19.75 9.125H11.875V12.875H19.75C20.3713 12.875 20.875 13.3787 20.875 14C20.875 14.6213 20.3713 15.125 19.75 15.125H11.875V20C11.875 20.6213 11.3713 21.125 10.75 21.125C10.1287 21.125 9.625 20.6213 9.625 20Z" />
      <path d="M18.625 5C18.625 3.96447 17.7855 3.125 16.75 3.125H4.75C3.71447 3.125 2.875 3.96447 2.875 5V17C2.875 18.0355 3.71447 18.875 4.75 18.875H16.75C17.7855 18.875 18.625 18.0355 18.625 17V5ZM20.875 17C20.875 19.2782 19.0282 21.125 16.75 21.125H4.75C2.47183 21.125 0.625 19.2782 0.625 17V5C0.625 2.72183 2.47183 0.875 4.75 0.875H16.75C19.0282 0.875 20.875 2.72183 20.875 5V17Z" />
    </svg>
  );
}
